import { JobTable } from './JobTable';
import './Job.scss';

export const JobResults = () => {
  return <JobTable />;
};
